import { useState } from 'react';
import { Button, Card, Grid, Text } from '@mantine/core';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router';
import useFetch from '../../helpers/useFetch';
import { setTiktokAccount as setTiktokAccountRedux } from '../../store/tiktokSlice';
import ErrorMessage from '../ErrorMessage';

const TikTokDisconnectButton = ({ setTiktokAccount }) => {
  const fetch = useFetch();
  const dispatch = useDispatch();
  const [error, setError] = useState();
  const [disabled, setDisabled] = useState(false);
  const { accountId, domainId } = useParams();

  const logout = async () => {
    setDisabled(true);
    return fetch(`/api/admin/accounts/${accountId}/domains/${domainId}/tiktok/logout`, {
      method: 'POST',
    })
      .then(() => {
        setTiktokAccount(null);
        dispatch(setTiktokAccountRedux(null));
      })
      .catch((error) => {
        console.log(error);
        setError('TitTok logout failed, please try again later or contact support!');
      });
  };

  return (
    <Card withBorder>
      <Card.Section inheritPadding py="sm">
        <Grid>
          <Grid.Col span={{ base: 12, sm: 4 }}>
            <Text size="sm" fw={500}>Connection</Text>
          </Grid.Col>
          <Grid.Col span={{ base: 12, sm: 8 }}>
            <Button
              variant="filled"
              onClick={() => logout().finally(() => setDisabled(false))}
              disabled={disabled}
            >
              Disconnect TikTok from Releva
            </Button>

            <ErrorMessage message={error} />
          </Grid.Col>
        </Grid>
      </Card.Section>
    </Card>
  );
};

export default TikTokDisconnectButton;
